export const blockScroll = () => {
  document.querySelector('html')?.classList.toggle('page-scroll');
};